import { Toast } from 'primereact/toast';
import { MutableRefObject } from 'react';

export const showSuccessfullToast = (successfullToastRef: MutableRefObject<Toast | null>) => {
  setTimeout(() => {
    successfullToastRef?.current?.show({
      summary: 'The export has been completed successfully.',
      life: 3000,
    });
  }, 1500);

  setTimeout(() => {
    successfullToastRef.current?.clear();
  }, 3000);
};

export const showDownloadToast = (downloadToastRef: MutableRefObject<Toast | null>) => {
  downloadToastRef?.current?.show({
    summary: 'Exporting...',
    detail: 'export',
    closable: true,
  });
};

export const clearDownloadToast = (
  setQueryNumber: (q: number) => void,
  setProgressValueToast: (p: number) => void,
  interval: MutableRefObject<number | null>,
  downloadToastRef: MutableRefObject<Toast | null>,
) => {
  setProgressValueToast(0);
  setQueryNumber(0);
  clearInterval(0);
  interval.current = 0;
  downloadToastRef?.current?.clear();
};
